import { qualifyUrls } from "routing/Routes";
const CollectionsRoutes = {
  LIST: "/collections",
  show: (id) => `/collections/${id}`
};
const routes = qualifyUrls(CollectionsRoutes);
export default {
  ...routes,
  unqualified: CollectionsRoutes
};
